import { comics } from "@/mocks/comics";
import { formatLikes, formatViews } from "./format";

const updates = [...comics].slice(0, 7);
const topList = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);
const tagCloud = [
  "沙雕",
  "无厘头",
  "神转折",
  "脑洞",
  "魔性",
  "奇葩",
  "穿越",
  "职场",
  "反套路",
  "逆袭",
  "治愈",
  "爆笑",
];

export default function FollowSection() {
  return (
    <section id="follow" className="relative w-full bg-background-100 py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-10">
          <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-bold mb-1">
            <i className="ri-sparkling-2-fill" aria-hidden="true"></i>
            每日精选
          </span>
          <h2 className="font-heading text-foreground-950 text-2xl md:text-4xl">追更专区</h2>
          <p className="text-foreground-600 text-sm mt-2 max-w-xl mx-auto">
            最新话更新、阅读热度榜、热门标签，三分钟掌握今天该追哪本。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {/* Recent updates */}
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-foreground-950 text-lg md:text-xl">最近更新</h3>
              <span className="text-xs text-foreground-500">今日已更新 36 话</span>
            </div>
            <div className="flex flex-col gap-3">
              {updates.map((c) => (
                <div
                  key={c.id}
                  className="group flex items-center gap-3 md:gap-4 p-2.5 md:p-3 rounded-xl bg-background-50 border-2 border-background-200 hover:border-primary-300 transition"
                >
                  <div className="w-14 h-[84px] md:w-16 md:h-24 shrink-0 rounded-lg overflow-hidden bg-background-200">
                    <img
                      src={c.cover}
                      alt={`${c.title}最新话封面`}
                      loading="lazy"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h4 className="font-heading text-foreground-950 text-sm md:text-base">
                        {c.title}
                      </h4>
                      <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-[11px]">
                        {c.category}
                      </span>
                      {c.status === "完结" && (
                        <span className="px-2 py-0.5 rounded-md bg-foreground-100 text-foreground-600 text-[11px]">
                          完结
                        </span>
                      )}
                    </div>
                    <p className="text-foreground-600 text-xs mt-1 truncate">{c.description}</p>
                    <div className="flex items-center gap-3 mt-1.5 text-[11px] text-foreground-500">
                      <span>
                        更新至 <b className="text-primary-700">第{c.chapters}话</b>
                      </span>
                      <span>{c.update}</span>
                    </div>
                  </div>
                  <a
                    href="#follow"
                    className="shrink-0 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-xs md:text-sm font-bold hover:bg-primary-600 transition whitespace-nowrap"
                  >
                    追更
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Sidebar */}
          <aside className="flex flex-col gap-6">
            <div className="rounded-2xl bg-background-50 border-2 border-background-200 p-4 md:p-5">
              <h3 className="font-heading text-foreground-950 text-lg flex items-center gap-2 mb-4">
                <i className="ri-trophy-fill text-secondary-500" aria-hidden="true"></i>
                阅读热度榜
              </h3>
              <ol className="flex flex-col gap-1">
                {topList.map((c, i) => (
                  <li key={c.id}>
                    <a
                      href="#follow"
                      className="flex items-center gap-3 py-2 px-2 rounded-lg hover:bg-background-100 transition"
                    >
                      <span
                        className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center font-heading text-sm ${
                          i < 3 ? "bg-accent-500 text-background-50" : "bg-secondary-200 text-secondary-800"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="flex-1 min-w-0 truncate text-sm text-foreground-800">
                        {c.title}
                      </span>
                      <span className="text-[11px] text-foreground-500 flex items-center gap-1 shrink-0">
                        <i className="ri-eye-line" aria-hidden="true"></i>
                        {formatViews(c.views)}
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-2xl bg-background-50 border-2 border-background-200 p-4 md:p-5">
              <h3 className="font-heading text-foreground-950 text-lg flex items-center gap-2 mb-4">
                <i className="ri-price-tag-3-fill text-primary-500" aria-hidden="true"></i>
                热门标签
              </h3>
              <div className="flex flex-wrap gap-2">
                {tagCloud.map((tag, i) => (
                  <a
                    key={tag}
                    href="#category"
                    className={`px-3 py-1 rounded-full text-xs transition hover:scale-105 ${
                      i % 4 === 0
                        ? "bg-primary-100 text-primary-700"
                        : i % 4 === 1
                          ? "bg-secondary-100 text-secondary-800"
                          : i % 4 === 2
                            ? "bg-accent-100 text-accent-700"
                            : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    # {tag}
                  </a>
                ))}
              </div>
            </div>

            <div className="rounded-2xl bg-primary-500 halftone-light p-4 md:p-5 text-center">
              <p className="font-heading text-background-50 text-lg">喜欢的漫画支持一键收藏</p>
              <p className="text-background-100/90 text-xs mt-1 mb-3">
                把最爱追更的沙雕漫画加入书架，更新第一时间提醒
              </p>
              <a
                href="#follow"
                className="inline-block px-5 py-2 rounded-full bg-background-50 text-primary-700 text-sm font-bold hover:bg-secondary-200 transition whitespace-nowrap"
              >
                收藏追更
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}